import React from "react";
import useEmblaCarousel from 'embla-carousel-react';

import SingleWidthCard from "./single-width-card";

const PostSlider = ({ overflow, posts, useClientName }) => {
    const [emblaRef] = useEmblaCarousel({ loop: true,  align: 'center' });

    return(
        <div className="embla post-slider-container" ref={emblaRef}>
            <div className="embla__container">
                {((typeof posts.edges.length !== "undefined") && (posts.edges.length !== 0)) &&
                    (posts.edges.map((post, index) => (
                        <div key={ `postCard-${index}` } className="embla__slide">
                            <SingleWidthCard
                                data={ post } 
                                services = { post.servicesTaxonomy } 
                                useClientName={ useClientName } 
                                type={ "case-study" } 
                            />
                        </div>
                    )))
                }
            </div>
        </div>
    );
}

export default PostSlider;